import { DateRangePreset } from "@/types/report.types";
import { calculateDateRange, formatDateRangeForDisplay } from "@/utils/date.utils";

export const reportTypes = [
  { value: "Orders", label: "generateReport.types.orders" },
  { value: "Tips", label: "generateReport.types.tips" },
];

// Generate date range descriptions for each preset option
const getDateRangeDescription = (preset: DateRangePreset): string | undefined => {
  if (preset === DateRangePreset.CUSTOM) return undefined;
  
  const dateRange = calculateDateRange(preset);
  if (!dateRange) return undefined;
  
  return formatDateRangeForDisplay(dateRange.startDate, dateRange.endDate);
};

export const dateRangePresetOptions = [
  {
    value: DateRangePreset.TODAY,
    label: "generateReport.datePresets.today",
    description: getDateRangeDescription(DateRangePreset.TODAY),
  },
  {
    value: DateRangePreset.YESTERDAY,
    label: "generateReport.datePresets.yesterday",
    description: getDateRangeDescription(DateRangePreset.YESTERDAY),
  },
  {
    value: DateRangePreset.THIS_WEEK_TO_DATE,
    label: "generateReport.datePresets.thisWeekToDate",
    description: getDateRangeDescription(DateRangePreset.THIS_WEEK_TO_DATE),
  },
  {
    value: DateRangePreset.LAST_7_DAYS,
    label: "generateReport.datePresets.last7Days",
    description: getDateRangeDescription(DateRangePreset.LAST_7_DAYS),
  },
  {
    value: DateRangePreset.LAST_WEEK,
    label: "generateReport.datePresets.lastWeek",
    description: getDateRangeDescription(DateRangePreset.LAST_WEEK),
  },
  {
    value: DateRangePreset.LAST_MONTH,
    label: "generateReport.datePresets.lastMonth",
    description: getDateRangeDescription(DateRangePreset.LAST_MONTH),
  },
  {
    value: DateRangePreset.LAST_QUARTER,
    label: "generateReport.datePresets.lastQuarter",
    description: getDateRangeDescription(DateRangePreset.LAST_QUARTER),
  },
  {
    value: DateRangePreset.LAST_YEAR,
    label: "generateReport.datePresets.lastYear",
    description: getDateRangeDescription(DateRangePreset.LAST_YEAR),
  },
  {
    value: DateRangePreset.THIS_YEAR_TO_DATE,
    label: "generateReport.datePresets.thisYearToDate",
    description: getDateRangeDescription(DateRangePreset.THIS_YEAR_TO_DATE),
  },
  {
    value: DateRangePreset.CUSTOM,
    label: "generateReport.datePresets.custom",
  },
];

// Date validation constants
export const MAX_HISTORICAL_YEARS = 3;  // Maximum years in the past for reports
export const MAX_DATE_RANGE_YEARS = 1; // Maximum range between start and end dates in years
export const MAX_EMAILS = 10; // Matches ReportRequest.MaxRecipients in the backend
export const MAX_EMAIL_LENGTH = 100;
